var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    transform: "translate(18 15)",
    d: "M4.3244648 6.976337L4.3244648 12L1.9623541 12L1.9623541 6.976337L0 6.976337L0 4.9393544L1.9623541 4.9393544L1.9623541 4.1982169C1.9623541 1.4467372 3.1388648 0 5.6281562 0C6.3912935 0 6.5820823 0.11982171 7 0.21745543L7 2.2322571C6.5321088 2.1523714 6.400383 2.1079886 5.9143305 2.1079886C5.3374367 2.1079886 5.0285392 2.26776 4.7469091 2.5828457C4.4652796 2.8979313 4.3244648 3.4437943 4.3244648 4.2248573L4.3244648 4.9437943L7 4.9437943L6.2822738 6.9807773L4.3244648 6.9807773L4.3244648 6.976337Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.6b5b15fafae1353db3b69c1fd1b05cd1.svg";
export { ForwardRef as ReactComponent };